import { capitalize, resizeVtexImage } from "@core/utils";
import { getItemCategory, getItemCategory2 } from '../utils'
import type { InitialConfig, ItemsResponse } from "@src/types";
import type {
  HeadlessBrandContext,
  HeadlessItemsPDCContext,
  HeadlessLineItemsPDCContext,
  HeadlessValuePDCContext,
} from "../types"

export const HeadlessPdcZone = {
  items: (context: HeadlessItemsPDCContext): ItemsResponse[] | null => {
    if (context?.items) return context.items

    if (context?.products) {
      return context.products.map((item) => {
        const listPrice = item.offers.highPrice
        const price = item.offers.lowPrice

        return {
          quantity: 1,
          index: item?.index ?? 0,
          item_brand: capitalize(item.brand.name) ?? null,
          item_name: item.name ?? null,
          price: price ?? null,
          item_shipping_tier: null,
          discount: Number(listPrice) - Number(price),
          item_variant: item.isVariantOf?.hasVariant?.[0].name.split(" - ")[0] ?? null,
          item_variant2: (item.additionalProperty ?? []).find((p) => p.name === 'Tamanho')?.value as string ?? null,
          item_ref: null, // sem ref no retorno do IS na multi-lib produtos PDC
          item_category: getItemCategory(item),
          item_category2: getItemCategory2(item) ?? null,
          item_id: item.isVariantOf.productGroupID ?? null,
          item_sku: item.sku ?? null,
          item_url: null, // sem link/url no retorno do IS na multi-lib produtos PDC
          image_url: resizeVtexImage(item?.image?.[0].url) ?? null,
          seller_id: item.offers?.offers?.find(o => o.availability)?.seller?.identifier ?? null,
          item_list_name: item.item_list_name ?? null,
        }
      })
    }

    return null;
  },

  value: (context: HeadlessValuePDCContext): number | null => {
    if (context?.value) return context.value

    if (context?.products) {
      return context.products
        .map((item) => item.offers.lowPrice)
        .filter((price): price is number => price !== undefined)
        .reduce((sum, price) => sum + price, 0)
    }

    return null
  },

  line_items: (context: HeadlessLineItemsPDCContext): string | null => {
    if (context?.line_items) return context.line_items;

    if (context?.products) {
      return context.products
        .map((item) => item.id)
        .filter((id): id is string => Boolean(id))
        .join()
    }

    return null;
  },

  brand: (context: HeadlessBrandContext, config: InitialConfig): string | null => {
    if (config?.brand) return config.brand
    if (context?.brand) return context.brand
    if (context?.products) {
      return context.products.map((p) => p.brand.name).join().trim()
    }

    return null
  },
}